const inventory = {
  title: "Inventario",
  subtitle: "Gestioná tus insumos, tratamientos y su consumo.",
  back: "Volver",
  loading: "Cargando…",

  currencyAlert:
    'Para poder utilizarlo correctamente, recomendamos completar el apartado de "Monedas".',
  goToCurrencies: "Ir a Monedas",
  currencyAlertSecretary:
    'El profesional todavía no completó el apartado de "Monedas" en su perfil.',

  // Secretaria: inventario de cada uno de sus profesionales
  owner: {
    label: "Inventario de",
    placeholder: "Elegí un profesional",
    noProfessionals:
      "Todavía no trabajás con ningún profesional, así que no hay inventarios para ver.",
  },

  reorderTitle: "Insumos a reponer",
  reorderEmpty: "Stock en condiciones normales",
  reorderHint: "Estos insumos alcanzaron o superaron su quiebre de stock.",

  expiringTitle: "Insumos por vencer",
  expiringEmpty: "No hay insumos próximos a vencer",
  expiringHint: "Estos insumos alcanzaron su fecha de alerta por vencimiento o ya vencieron.",
  expiresOn: "Vence el {{date}}",
  expiredOn: "Venció el {{date}}",

  nav: {
    supplies: "Insumos",
    newSupply: "+ Insumo",
    suppliesList: "Listado Insumos",
    treatments: "Tratamientos",
    newTreatment: "Tratamiento",
    charts: "Gráficos",
    currencies: "Monedas",
  },

  // Monedas (settings)
  currencies: {
    title: "Monedas",
    defaultTitle: "Moneda predeterminada",
    defaultDescription: "ésta es la moneda principal",
    selectCurrency: "Seleccioná una moneda",
    decimalQuestion: "¿Cómo deseas que se vean las posiciones decimales?",
    decimalComma: "Coma ( , )",
    decimalDot: "Punto ( . )",
    altTitle: "Moneda alternativa",
    altDescription: "moneda de conversión, para aquellos insumos que lo posean",
    exchangeRate: "Tipo de cambio",
    exchangeRatePlaceholder: "Ingresá el valor",
    lastUpdate: "Última Actualización",
    notUpdatedYet: "Sin actualizar",
    exchangeHint:
      "El valor que ingreses será multiplicado por la moneda predeterminada. Si tu moneda es Pesos Argentinos (AR$) y posees insumos en Dólares Estadounidense (U$S), el valor que ingreses en el campo reflejará el precio en Pesos Argentinos. Ejemplo: mi bisturí favorito tiene un valor de U$S 500 y el valor del Dólar es de AR$ 2000 por U$S 1, el sistema te mostrará en el listado de insumos el precio de AR$ 1.000.000 con la posición decimal que hayas seleccionado.",
    save: "Guardar",
    saved: "Configuración de monedas guardada",
    saveError: "Error al guardar la configuración",
  },

  // Insumos
  supply: {
    newTitle: "Nuevo Insumo",
    editTitle: "Editar Insumo",
    decimalHint:
      'En caso de tener costos con posiciones decimales ingresalas de la misma manera que seleccionaste en el apartado de "Monedas".',
    description: "Descripción",
    descriptionPlaceholder: "Descripción del insumo",
    stock: "Stock",
    stockHint: "stock actual",
    unitCostIn: "Costo Unitario en {{currency}}",
    unitCostAltIn: "Costo Unitario en {{currency}} (moneda alternativa)",
    reorderThreshold: "Quiebre de stock",
    reorderThresholdHint: "Te avisaremos cuando el insumo llegue a este número.",
    comments: "Comentarios",
    commentsPlaceholder:
      "algo que quieras aclarar del insumo. Por ejemplo: 1 unidad equivale a 0.5 metros",
    lastUpdate: "Última actualización",
    zeroNote:
      "Importante: si un insumo llega a 0 o menos de 0, el sistema seguirá funcionando.",
    create: "Crear Insumo",
    save: "Guardar",
    created: "Insumo creado",
    updated: "Insumo actualizado",
    saveError: "Error al guardar el insumo",
    requiredDescription: "Ingresá la descripción del insumo",
    requiredThreshold: "Ingresá el quiebre de stock",
    expirationDate: "Fecha de vencimiento",
    expirationDateHint: "opcional, si el insumo vence",
    expirationAlertDate: "Alerta por vencimiento",
    alertOneMonth: "1 mes antes",
    alertOneAndHalfMonths: "1 mes y medio antes",
    expirationAlertHint:
      "Elegí la fecha en la que querés que te avisemos antes del vencimiento. Si tu producto tiene 6 meses de vencimiento, te recomendamos elegir un mes y medio o un mes antes para disparar la alerta por reposición.",
    requiredExpirationForAlert: "Ingresá la fecha de vencimiento para usar la alerta",
    alertAfterExpiration: "La fecha de alerta debe ser anterior o igual a la fecha de vencimiento",
    configureCurrencyFirst:
      'Configurá primero el apartado "Monedas" para elegir tu moneda predeterminada.',
  },

  // Listado de insumos
  list: {
    searchPlaceholder: "Buscar insumo por descripción…",
    description: "Descripción",
    lastUpdate: "Última actualización",
    stock: "Stock",
    history: "Historial",
    actions: "Acciones",
    edit: "Editar",
    empty: "Aún no tienes insumos cargados",
    delete: "Eliminar",
    confirmDelete: "¿Estás seguro que deseas eliminar este insumo?",
    deleted: "Insumo eliminado",
    expiration: "Vence",
  },

  // Historial de insumo
  history: {
    title: "Historial de {{name}}",
    date: "Fecha",
    change: "Cambio",
    stock: "Stock",
    unitCost: "Costo unitario",
    expiration: "Vencimiento",
    empty: "Sin movimientos registrados",
    types: {
      create: "Creación",
      update: "Edición",
      consumption: "Consumo",
      adjustment: "Ajuste",
    },
  },

  // Tratamientos
  treatment: {
    listTitle: "Tratamientos",
    intro:
      "No te preocupes por ir tan al detalle. Si a un paciente le asignas un tratamiento, te preguntaremos antes de guardar lo utilizado.",
    empty: "Aún no tienes tratamientos",
    newTitle: "Nuevo Tratamiento",
    editTitle: "Editar Tratamiento",
    name: "Nombre",
    namePlaceholder: "Peeling químico, APEX, BOTOX, COLELAP, etc.",
    supplies: "Insumos",
    suppliesHint: "selecciona el insumo y cantidad que utiliza cada tratamiento",
    searchSupply: "Buscar insumo por nombre…",
    quantity: "Cantidad",
    unitCost: "Costo unitario",
    subtotal: "Subtotal",
    subtotalIn: "Subtotal {{currency}}",
    add: "Agregar",
    remove: "Eliminar",
    selectedSupplies: "Insumos del tratamiento",
    noSupplies: "Todavía no agregaste insumos",
    totalCost: "Costo total del tratamiento",
    totalCostPrivate: "ésta información es privada",
    noExchangeRate: "Configurá el tipo de cambio en Monedas",
    lastUpdate: "Última actualización",
    save: "Guardar Tratamiento",
    created: "Tratamiento creado",
    updated: "Tratamiento actualizado",
    saveError: "Error al guardar el tratamiento",
    requiredName: "Ingresá el nombre del tratamiento",
    requiredItems: "Agregá al menos un insumo",
    edit: "Editar",
    stats: "Estadísticas",
    delete: "Eliminar",
    confirmDelete: "¿Estás seguro que deseas eliminar este tratamiento?",
    deleted: "Tratamiento eliminado",
  },

  // Estadísticas de tratamiento
  stats: {
    title: "Estadísticas de {{name}}",
    timesUsed: "Veces utilizado",
    totalCost: "Costo acumulado",
    lastUsed: "Último uso",
    never: "Nunca",
    monthlyUsage: "Uso por mes",
    empty: "Este tratamiento aún no se utilizó",
  },

  // Consumo desde historia clínica
  consumption: {
    title: "Consumo de insumos",
    question:
      "¿Utilizaste todos los insumos de \"{{name}}\"? Modificalas en la siguiente tabla en caso de ser necesario y se actualizará el stock.",
    supply: "Insumo",
    quantity: "Cantidad utilizada",
    confirm: "Confirmar",
    cancel: "Cancelar",
    applied: "Consumo registrado y stock actualizado",
    applyError: "Error al registrar el consumo",
    selectTreatment: "Tratamiento (opcional)",
    selectTreatmentPlaceholder: "Sin tratamiento",
    noTreatments: "No tienes tratamientos creados",
  },

  // Gráficos
  charts: {
    title: "Gráficos",
    treatmentConsumption: "Consumo de tratamientos",
    supplyConsumption: "Consumo de insumos",
    topTreatments: "Top 5 tratamientos más utilizados",
    topSupplies: "Top 5 insumos más utilizados",
    empty: "Todavía no hay datos suficientes para mostrar",
    count: "Cantidad",
    quantity: "Cantidad",
  },

  common: {
    saving: "Guardando…",
    cancel: "Cancelar",
    close: "Cerrar",
  },
};

export default inventory;
